webpackJsonp([597],{

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX releases | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2000:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1046),
  /* template */
  __webpack_require__(2793),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/changelog-81.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] changelog-81.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fb768da", Component.options)
  } else {
    hotAPI.reload("data-v-5fb768da", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2793:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX releases")]), _vm._v(" "), _c('h2', [_vm._v("next (not release yet)")]), _vm._v(" "), _c('h3', [_vm._v("Selector")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix the chinese bracket show error when direction=rtl "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2864",
      "target": "_blank"
    }
  }, [_vm._v("#2864")])])])]), _vm._v(" "), _c('h3', [_vm._v("VChart")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  v-point can set size and shape, v-line can set shape")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.9.2.html"
    }
  }, [_vm._v("v2.9.2")])]), _vm._v(" "), _c('h3', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  Support prop: showCancelButton showConfirmButton "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2795",
      "target": "_blank"
    }
  }, [_vm._v("#2795")])])])]), _vm._v(" "), _c('h3', [_vm._v("DatetimeView")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix render error for DOM not found "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2797",
      "target": "_blank"
    }
  }, [_vm._v("#2797")])])])]), _vm._v(" "), _c('h3', [_vm._v("Range")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  add on-touchstart and on-touchend events "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2804",
      "target": "_blank"
    }
  }, [_vm._v("#2804")])])])]), _vm._v(" "), _c('h3', [_vm._v("Swiper")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix stuck swipe after setting min-moving-distance "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2773",
      "target": "_blank"
    }
  }, [_vm._v("#2773")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix error for repeat setting data in loop "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2803",
      "target": "_blank"
    }
  }, [_vm._v("#2803")])])])]), _vm._v(" "), _c('h3', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  support styles variable for button "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2748",
      "target": "_blank"
    }
  }, [_vm._v("#2748")])])])]), _vm._v(" "), _c('h3', [_vm._v("XImg")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-enhance"
  }, [_vm._v("enhance")]), _vm._v("  Support prop:separator "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2744",
      "target": "_blank"
    }
  }, [_vm._v("#2744")])])])]), _vm._v(" "), _c('h3', [_vm._v("XInput")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix corsor misplce when set mask "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2810",
      "target": "_blank"
    }
  }, [_vm._v("#2810")])])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.9.1.html"
    }
  }, [_vm._v("v2.9.1")])]), _vm._v(" "), _c('h3', [_vm._v("Alert")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  add isVisible function for AlertPlugin "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2704",
      "target": "_blank"
    }
  }, [_vm._v("#2704")])])])]), _vm._v(" "), _c('h3', [_vm._v("Confirm")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  add isVisible function for ConfirmPlugin "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2704",
      "target": "_blank"
    }
  }, [_vm._v("#2704")])])])]), _vm._v(" "), _c('h3', [_vm._v("Loading")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  add isVisible function for LoadingPlugin "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2704",
      "target": "_blank"
    }
  }, [_vm._v("#2704")])])]), _c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix covered by element when using scroll plugins")])])]), _vm._v(" "), _c('h3', [_vm._v("Popup")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fixed popup has black border on the right "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2651",
      "target": "_blank"
    }
  }, [_vm._v("#2651")])])])]), _vm._v(" "), _c('h3', [_vm._v("Qrcode")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix missing support for Chinese works "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2652",
      "target": "_blank"
    }
  }, [_vm._v("#2652")])])])]), _vm._v(" "), _c('h3', [_vm._v("Tab")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-fix"
  }, [_vm._v("fix")]), _vm._v("  fix box-sizing issue "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2621",
      "target": "_blank"
    }
  }, [_vm._v("#2621")]), _vm._v(" . thanks to "), _c('a', {
    attrs: {
      "href": "https://github.com/suncodeer",
      "target": "_blank"
    }
  }, [_vm._v("@suncodeer")])])])]), _vm._v(" "), _c('h3', [_vm._v("Toast")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  add isVisible function for ToastPlugin "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/issues/2704",
      "target": "_blank"
    }
  }, [_vm._v("#2704")])])])]), _vm._v(" "), _c('h3', [_vm._v("XCircle")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('span', {
    staticClass: "change change-feature"
  }, [_vm._v("feature")]), _vm._v("  support show percent anticlockwise")])])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.9.0.html"
    }
  }, [_vm._v("v2.9.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.8.1.html"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.8.0.html"
    }
  }, [_vm._v("v2.8.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.9.html"
    }
  }, [_vm._v("v2.7.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.8.html"
    }
  }, [_vm._v("v2.7.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.7.html"
    }
  }, [_vm._v("v2.7.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/2.7.6.html"
    }
  }, [_vm._v("2.7.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.6.html"
    }
  }, [_vm._v("v2.7.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.5.html"
    }
  }, [_vm._v("v2.7.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.4.html"
    }
  }, [_vm._v("v2.7.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.3.html"
    }
  }, [_vm._v("v2.7.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.2.html"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.1.html"
    }
  }, [_vm._v("v2.7.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.7.0.html"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.5.html"
    }
  }, [_vm._v("v2.6.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.4.html"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.3.html"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.2.html"
    }
  }, [_vm._v("v2.6.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.1.html"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.6.0.html"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.12.html"
    }
  }, [_vm._v("v2.5.12")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.11.html"
    }
  }, [_vm._v("v2.5.11")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.10.html"
    }
  }, [_vm._v("v2.5.10")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.9.html"
    }
  }, [_vm._v("v2.5.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.8.html"
    }
  }, [_vm._v("v2.5.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.7.html"
    }
  }, [_vm._v("v2.5.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.6.html"
    }
  }, [_vm._v("v2.5.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.5.html"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.4.html"
    }
  }, [_vm._v("v2.5.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.3.html"
    }
  }, [_vm._v("v2.5.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.2.html"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.1.html"
    }
  }, [_vm._v("v2.5.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.5.0.html"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.4.1.html"
    }
  }, [_vm._v("v2.4.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.4.0.html"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.8.html"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.7.html"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.6.html"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.5.html"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.4.html"
    }
  }, [_vm._v("v2.3.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.3.html"
    }
  }, [_vm._v("v2.3.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.2.html"
    }
  }, [_vm._v("v2.3.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.3.1.html"
    }
  }, [_vm._v("v2.3.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.2.html"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1.html"
    }
  }, [_vm._v("v2.2.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.8.html"
    }
  }, [_vm._v("v2.2.1-rc.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.7.html"
    }
  }, [_vm._v("v2.2.1-rc.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.6.html"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.4.html"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.3.html"
    }
  }, [_vm._v("v2.2.1-rc.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.2.html"
    }
  }, [_vm._v("v2.2.1-rc.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.1-rc.1.html"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.2.0.html"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.14.html"
    }
  }, [_vm._v("v2.1.1-rc.14")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.13.html"
    }
  }, [_vm._v("v2.1.1-rc.13")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.12.html"
    }
  }, [_vm._v("v2.1.1-rc.12")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.11.html"
    }
  }, [_vm._v("v2.1.1-rc.11")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.10.html"
    }
  }, [_vm._v("v2.1.1-rc.10")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.9.html"
    }
  }, [_vm._v("v2.1.1-rc.9")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.8.html"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.7.html"
    }
  }, [_vm._v("v2.1.1-rc.7")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.6.html"
    }
  }, [_vm._v("v2.1.1-rc.6")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.5.html"
    }
  }, [_vm._v("v2.1.1-rc.5")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.4.html"
    }
  }, [_vm._v("v2.1.1-rc.4")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.3.html"
    }
  }, [_vm._v("v2.1.1-rc.3")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.2.html"
    }
  }, [_vm._v("v2.1.1-rc.2")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.1-rc.1.html"
    }
  }, [_vm._v("v2.1.1-rc.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0.html"
    }
  }, [_vm._v("v2.1.0")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.51.html"
    }
  }, [_vm._v("v2.1.0-rc.51")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.50.html"
    }
  }, [_vm._v("v2.1.0-rc.50")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.49.html"
    }
  }, [_vm._v("v2.1.0-rc.49")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.48.html"
    }
  }, [_vm._v("v2.1.0-rc.48")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.47.html"
    }
  }, [_vm._v("v2.1.0-rc.47")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.1.0-rc.46.html"
    }
  }, [_vm._v("v2.1.0-rc.46")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.0.14.html"
    }
  }, [_vm._v("v2.0.14")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.0.1.html"
    }
  }, [_vm._v("v2.0.1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/changelog/v2.0.0.html"
    }
  }, [_vm._v("v2.0.0")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fb768da", module.exports)
  }
}

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2000);

/***/ })

});


// WEBPACK FOOTER //
// 597.6f244f50.js